let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lARJZ")).then(() => parcelRequire('bmYyf'));